window['$'] = window['jQuery'] = require("../../../static/js/jquery/jquery-2.1.4.min.js");
require("../../../static/js/jquery/jquery.browser.min.js");
window['Highcharts'] = require("../../../static/au/js/highcharts.js");
require("../../../static/au/js/boost.js");
require("../../../static/au/js/accessibility.js");
require("../../../static/au/js/exporting.js");
require("../../../static/au/js/main_etf.js");
require("../../../static/au/js/jquery.responsiveiframe.js");
require("../../../static/au/js/global-nav.js");
require("../../../static/js/AC_ActiveX.js");
require("../../../static/js/AC_RunActiveContent.js");
require("../../../static/au/js/disclaimerpopup.js");
require("../../../static/plugins/bootstrap/3.3.6/js/bootstrap.min.js");
window['Spinner'] = require("../../../static/js/spin.min.js");
require("../../../static/au/js/spinner.js");
require("../../../static/au/js/mobile-responsive.js");
require("../../../static/au/js/jquery.jqtransform.js");
require("../../../static/au/js/etf-selector-core.js");
require("../../../static/au/js/jquery.tablesorter.js");
require("../../../static/au/js/jquery.tablesorter.widgets.js");
require("../../../static/au/js/widget-reflow.min.js");
